import { Component, Inject, Injector } from '@angular/core';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { ApiUrl } from 'src/assets/constants';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-password-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,  
    HttpClientModule
  , TranslateModule],
  templateUrl: './password-dialog.component.html',
  styleUrl: './password-dialog.component.scss'
})
export class PasswordDialogComponent {
  password: string = ''; 
  passwordVisible: boolean = false;
  email: any;

  constructor(
    public dialogRef: MatDialogRef<PasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, 
    private injector: Injector,
    private cookieService: CookieService,
    private toastr: ToastrService,
  ) { 
    this.email = JSON.parse(this.cookieService.get("userData")).email;
    
    // Set up dialog close handling
    this.dialogRef.backdropClick().subscribe(() => {
      this.dialogRef.close('cancelled');
    });
  }

  ngOnInit(): void {}

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  onCancel() {
    this.dialogRef.close('cancelled');
  }

  onSubmit(dialogRef: MatDialogRef<PasswordDialogComponent>) {
    if (!this.password.trim()) {
      return;
    }

    const http = this.injector.get(HttpClient);
    http.post(ApiUrl.CHECKPASSWORD, { 
      email: this.email,
      password: this.password
    }).subscribe(
      (data: any) => {
        this.cookieService.set("lockenabled",'false');
        this.dialogRef.close('unlocked');
      },
      (error: any) => {
        this.toastr.error(error.error.message); 
      }
    );
  }

  getToken(): string {
    return JSON.parse(this.cookieService.get("userData")).email;
  }
}
